import axios from "@/plugins/http/axios.js";
import config from "@/views/recognition/config/recognition.js";
import PathUri from "@/utils/path_uri";

const _pathUri = new PathUri(config.port, config.context);

export const service = {
  getTable: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/table`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  getCards: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/card`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  postSend: ({ idGroup, idEmpresa, idUsuario, payload }) => {
    return axios.post(
      `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/transaction/calculatePurchase`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          idEmpresa: idEmpresa,
          idUsuario: idUsuario,
        },
      }
    );
  },

  getPaymentMethon: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/paymentMethod`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  postPaymentSupport: (idGroup, idEmpresa, idUsuario, payment) => {
    return axios({
      method: "post",
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/payment`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
        "Content-Type": "multipart/form-data",
      },
      data: payment,
      redirect: "follow",
    });
  },

  tokenConfirmationReservation: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method:"post",
      url:  `${config.baseUrl + _pathUri.generateUri() + idGroup}/security/token/generate`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario
      },
    });
  },

  confirmReservation: (idGroup, idEmpresa, idUsuario, code) => {

    return axios.post(
      `${config.baseUrl + _pathUri.generateUri() + idGroup}/security/token/validate`,
      {
        userId: idUsuario,
        token: code
      },
      {
        headers: {
          idEmpresa: idEmpresa,
          idUsuario: idUsuario
        },
      }
    );
  },


  resendTokenConfirmationReservation: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method:"post",
      url:  `${config.baseUrl + _pathUri.generateUri() + idGroup}/security/token/resend`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario
      },
    });
  },

  postChangeStateStart: (idGroup, idEmpresa, idUsuario, data) => {
    return axios({
      method: "post",
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/shape/update-transaction-date`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
      data: data,
      redirect: "follow",
    });
  },


  getRecognitonCategories: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/core/categories`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },

  getCategories: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: "get",
      url: `${
        config.baseUrl + _pathUri.generateUri() + idGroup
      }/recognition/core/categories`,
      headers: {
        idEmpresa: idEmpresa,
        idUsuario: idUsuario,
      },
    });
  },


};
